import ResetPasswordForPopup from "./ResetPasswordForPopup";

export default ResetPasswordForPopup;